module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("slides"), _vm._v(" "), _c('div', {
    staticClass: "l-padding"
  }, [_c('div', {
    staticClass: "l-wrap--wide"
  }, [_c('div', {
    ref: "arrows",
    staticClass: "Slider-arrows"
  }, [_c('button', {
    ref: "prev",
    staticClass: "Slider-arrow prev"
  }, [_c('icon', {
    attrs: {
      "icon": "texture-arrow"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "u-screenreader"
  }, [_vm._v("Previous")])], 1), _vm._v(" "), _c('button', {
    ref: "next",
    staticClass: "Slider-arrow next"
  }, [_c('icon', {
    attrs: {
      "icon": "texture-arrow"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "u-screenreader"
  }, [_vm._v("Next")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "Slider-footer"
  }, [_vm._t("footer")], 2)])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d188ac74","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/vue/components/slider.vue
// module id = 350
// module chunks = 0